import * as angular from 'angular';

class NetworkPointDetailsShipperInfoCtrl implements ng.IController {
    public networkPointId: number;
    public networkPoint: NetworkPointDto;
    public price: any;
    public uiFavorNetworkPointError: boolean = false;
    public loggedInUser: LoginResult;
    public allAuctions: { [p: string]: any }[] = [];

    constructor(
        private NetworkPoint,
        private $location,
        private $anchorScroll,
        public DATES
    ) {}

    $onInit(): void {}

    public scrollTo(anchor): void {
        let old = this.$location.hash();
        this.$location.hash(anchor);
        this.$anchorScroll();
        this.$location.hash(old);
    }

    public favorNetworkPoint(favor): void {
        const onSuccess = () => {
            this.networkPoint.favoriteNetworkPoint = favor;
            this.uiFavorNetworkPointError = false;
        };
        const onError = () => {
            this.uiFavorNetworkPointError = true;
        };

        if (favor && !this.networkPoint.favoriteNetworkPoint) {
            this.NetworkPoint.favor(
                { id: this.networkPointId },
                onSuccess,
                onError
            );
        } else if (!favor && this.networkPoint.favoriteNetworkPoint) {
            this.NetworkPoint.disfavor(
                { id: this.networkPointId },
                onSuccess,
                onError
            );
        }
    }

    public onAuctionPromiseResolved(
        shortTermAuctions: AuctionShortTermDto[],
        longTermAuctions: AuctionLongTermDto[]
    ) {
        angular.forEach(shortTermAuctions, (shortTermAuction) => {
            this.allAuctions.push(shortTermAuction);
        });
        angular.forEach(longTermAuctions, (longTermAuction) => {
            this.allAuctions.push(longTermAuction);
        });
    }
}

angular.module('app').component('pkpNetworkPointDetailsShipperInfo', {
    controller: NetworkPointDetailsShipperInfoCtrl,
    template:
        require('app/network-point/network-point-details-shipper-info.component.html'),
    bindings: {
        networkPointId: '<',
        networkPoint: '<',
        loggedInUser: '<'
    }
});
